import _ from 'underscore'
import Backbone from 'backbone'
import ResultViewTemplate from '../templates/result.tpl'
import config from '../config'

const ResultView = Backbone.View.extend({
    tagName: 'tr',
    id: 'result-view',
    results: null,
    initialize(options) {
        this.template = _.template(ResultViewTemplate)
        this.dateFrom = options.dateFrom
        this.user = options.user

        // for when the app is purchased
        this.listenTo(this.model, 'change', this.render)
        // for when the ReportingView changes dateFrom value
        this.listenTo(this.dateFrom, 'change', this.resultsUpdated)
        // for when the ResultList.requestResults is fired
        this.listenTo(this.user.get('results'), 'add', this.resultsUpdated)

        // load locally saved results
        this.loadResults()
    },
    render() {
        this.$el.html(this.template({
            name: this.model.get('name'),
            purchased: this.model.get('purchased'),
            free: this.model.get('free'),
            stars: this.sum('star'),
            completed: this.results.length,
            score: this.sum('score'),
            total: this.sum('total'),
        }))
        return this
    },
    loadResults() {
        // get current milliseconds
        const date = new Date()
        const dateTo = date.getTime()

        this.results = this.user.get('results').select((model) => {
            return model.get('app_title') === config.get('id') &&
                model.get('level') === this.model.get('image_prefix') &&
                model.get('start_timestamp') >= this.dateFrom.get('milliseconds') &&
                model.get('start_timestamp') <= dateTo
        })
    },
    resultsUpdated() {
        this.loadResults()
        this.render()
    },
    sum(attribute) {
        return this.results.reduce((memo, value) => memo + value.get(attribute), 0)
    },
})

export default ResultView
